.ghostedText {
  min-height: 2rem;
  padding: 0;
  padding-top: 0.25em;
  width: 100%;
}

.multiline {
  white-space: break-spaces;
}
